import React from 'react'

import { Checkbox } from '@it-incubator/ui-kit'
import classNames from 'classnames'
import ReactMarkdown from 'react-markdown'

import style from './Answer.module.css'

import { RadioButton } from 'common/components'
import { useKeyDown } from 'common/hooks'
import { AnswerType, QuestionType } from 'common/types/entities'

type PropsType = {
  answer: AnswerType
  number: number
  selectedAnswers: string[]
  setSelectedAnswers: React.Dispatch<React.SetStateAction<string[]>>
  type: QuestionType
  isAnswered: boolean
}

export const Answer = ({
  answer,
  setSelectedAnswers,
  number,
  selectedAnswers,
  type,
  isAnswered,
}: PropsType) => {
  const toggleAnswer = () => {
    if (isAnswered) return

    if (selectedAnswers.includes(answer.id)) {
      if (type === 'radio') return

      setSelectedAnswers(selectedAnswers.filter(currAnswer => currAnswer !== answer.id))
    } else {
      if (type === 'radio') {
        setSelectedAnswers([answer.id])
      } else {
        setSelectedAnswers([...selectedAnswers, answer.id])
      }
    }
  }

  const getLabelClassName = () =>
    classNames(style.label, {
      [style['label--disabled']]: isAnswered,
      [style['label--correct']]:
        isAnswered && selectedAnswers.includes(answer.id) && answer.isCorrect,
      [style['label--incorrect']]:
        isAnswered && selectedAnswers.includes(answer.id) && !answer.isCorrect,
    })

  useKeyDown(toggleAnswer, String(number + 1), [selectedAnswers, isAnswered])

  return (
    <li className={style.box}>
      <label className={getLabelClassName()}>
        {type === 'checkbox' ? (
          <Checkbox
            onChange={toggleAnswer}
            checked={selectedAnswers.includes(answer.id)}
            disabled={isAnswered}
            className={style.checkbox}
          />
        ) : (
          <RadioButton
            name="question"
            onChange={toggleAnswer}
            checked={selectedAnswers.includes(answer.id)}
            disabled={isAnswered}
          />
        )}
        {/*<FormattedText text={answer.text} />*/}
        <ReactMarkdown className={style.markdown}>{answer.text}</ReactMarkdown>
      </label>
    </li>
  )
}
